
<template>
  <div>
    <div
      class="card mb-20">
      <header class="card-header pointer"
        @click="$emit('click-card')">
        <div class="card-header-title is-paddingless">
          <article class="media is-width-100p">
            <figure class="media-left mr-0">
              <p class="image is-160x160">
                <img :src="func.getImg(imageSrc)">
              </p>
            </figure>
            <div class="media-content">
              <div class="content pa-20">
                <div class="level mb-10">
                  <div class="level-left">
                    <b-tag class="mr-10" type="is-grid-1">
                      <p class="is-size-8">
                        {{pann.regie}}
                      </p>
                    </b-tag>
                    <b-tag
                      v-if="!func.isEmpty(pann.categorie)"
                      :style="styleTagCategorie"
                      class="mr-10">
                      <p class="is-size-8">
                        {{pann.categorie.libelle}}
                      </p>
                    </b-tag>
                    <b-tooltip
                      v-if="pann.estPanneauSousContrat && getInfoDateDemontage"
                      :label="getInfoDateDemontage"
                      position='is-right'>
                      <b-icon
                        icon="sign-caution"
                        type="is-warning">
                      </b-icon>
                    </b-tooltip>
                  </div>
                  <div class="level-right">
                    <a @click.stop="$emit('click-button')">
                      <b-icon
                        :icon="['new', 'old'].includes(type) ? 'delete' : 'reload'"
                        :type="['new', 'old'].includes(type) ? 'is-danger' : 'is-success'">
                      </b-icon>
                    </a>
                  </div>
                </div>
                <div class="mb-13">
                  <p v-if="pann.referencePanneau" class="is-size-7 mb-0 has-text-grid-1">
                    {{ pann.referencePanneau }} - {{$t('listePanneau.labelInfoPanneau.referenceConfrere')}} {{pann.referenceConfrere}}
                  </p>
                  <p v-if="pann.periodeContrat" class="is-size-7 mb-0 has-text-default">
                    {{ pann.periodeContrat }}
                  </p>
                  <p
                    v-if="pann.etatRenouvellement === 'NonRenouvelee'"
                    class="is-size-7 mb-0 has-text-grid-1">
                    {{$t('listePanneau.labelInfoPanneau.nonRenouvele')}} - {{pann.renouvellement}}
                  </p>
                  <p v-if="pann.adresseCommerciale" class="is-size-7 mb-0 has-text-grid-1">
                    {{pann.adresseCommerciale}}
                  </p>
                  <p class="is-size-7 mb-0 has-text-default has-text-weight-light">
                    {{ [pann.format, pann.materiel].filter(Boolean).join(' - ') }}
                  </p>
                </div>
                <div v-if="premierBudget" class="columns is-multiline">
                  <div class="column is-6">
                    <p class="is-size-7 mb-0 has-text-default has-text-weight-light">
                      {{$t('listePanneau.labelInfoPanneau.netBudgetaire')}}
                    </p>
                    <p class="is-size-7 mb-0 has-text-grid-1">
                      {{func.formatNombre(premierBudget.prixNet)}}
                    </p>
                  </div>
                  <div class="column is-6">
                    <p class="is-size-7 mb-0 has-text-default has-text-weight-light">
                      {{$t('listePanneau.labelInfoPanneau.tlpe')}}
                    </p>
                    <p class="is-size-7 mb-0 has-text-grid-1">
                      {{func.formatNombre(premierBudget.tlpe)}}
                    </p>
                  </div>
                  <div class="column is-6">
                    <p class="is-size-7 mb-0 has-text-default has-text-weight-light">
                      {{$t('listePanneau.labelInfoPanneau.honoraires')}}
                    </p>
                    <p class="is-size-7 mb-0 has-text-grid-1">
                      {{func.formatNombre(premierBudget.honoraires)}}
                    </p>
                  </div>
									<div class="column is-6">
										<p class="is-size-7 mb-0 has-text-default has-text-weight-light">
											{{$t('listePanneau.labelInfoPanneau.honoraireFraisTraitement')}}
										</p>
										<p class="is-size-7 mb-0 has-text-grid-1">
											{{func.formatNombre(premierBudget.honoraireFraisTraitement)}}
										</p>
									</div>
                  <div class="column is-6">
                    <p class="is-size-7 mb-0 has-text-default has-text-weight-light">
                      {{$t('listePanneau.labelInfoPanneau.fraisTechnique')}}
                    </p>
                    <p class="is-size-7 mb-0 has-text-grid-1">
                      {{func.formatNombre(premierBudget.fraisTechnique)}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEmpty, get } from 'lodash';
import getTextColor from '@/services/general/colorManager';
import { getImg, formatNombre, formatDate, adressFullStringGetter } from '@/services/general/general';
import { getSrcLogoById } from '@/services/general/indexDbLogoService';

export default {
  props: {
    panneau: Object,
    type: String,
  },
  data() {
    return {
      imageSrc: null,
      func: { getImg, formatNombre, isEmpty }
    }
  },
  computed: {
    premierBudget() {
      const budgets = this.panneau.budgets;
      return (budgets && budgets.length > 0) ? budgets[0] : null;
    },
    pann() {
      const data = cloneDeep(this.panneau);
      data.srcImg = data.srcImg || '';
      data.adresseCommerciale = adressFullStringGetter(data.adresse);
      if (!data.periodeContrat && this.premierBudget) {
        const { dateDebut, dateFin } = this.premierBudget;
        data.periodeContrat = `${formatDate(dateDebut)} au ${formatDate(dateFin)}`;
      }
      if (data.estPanneauSousContrat) {
        const libelleSousContrat = this.$t('listePanneau.labelInfoPanneau.sousContrat');
        data.periodeContrat = `${libelleSousContrat} ${data.periodeContrat}`;
      }
      return data;
    },
    styleTagCategorie() {
      const couleur = get(this.pann, 'categorie.couleur');
      if (!couleur) return {};
      return {
        color: getTextColor(couleur),
        backgroundColor: couleur,
      };
    },
    getInfoDateDemontage() {
      if (!this.pann.dateDemontage) return '';
      return `${this.$t('ajoutProduitExistant.dateDemontage')} ${formatDate(this.pann.dateDemontage)}`;
    },
  },
  async mounted() {
    this.imageSrc = !this.panneau.estPanneauSousContrat
      ? await getSrcLogoById(this.panneau.guid, this.panneau.srcImg)
      : this.panneau.srcImg;
  },
}
</script>
